let paramNames = ['professionalId'];
let url = new URL(window.location.href);

paramNames.forEach(param => {

    if (url.searchParams.has(param)) {
        setCookie(param, url.searchParams.get(param), 90);
    }

    if (hasCookie(param)) {
        writeAttributeIfNotExists(param, getCookie(param));
    }

});
if (url.searchParams.has('professionalId')) {
    if (url.searchParams.has('flow_version')) {
        setCookie('flow_version', url.searchParams.get('flow_version'), 90);
    } else {
        deleteCookie('flow_version');
    }
}

if (hasCookie('flow_version')) {
    writeAttributeIfNotExists('flow_version', getCookie('flow_version'));
} else {
    writeAttributeIfNotExists('flow_version', '');
}

function setCookie(name, value, days) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${name}=${encodeURIComponent(value)};expires=${expires};path=/;SameSite=Lax`;
}

function deleteCookie(name) {
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;SameSite=Lax`;
}

function getCookie(name) {
    const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
}

function hasCookie(name) {
    return getCookie(name) !== null;
}

function writeAttributeIfNotExists(paramname, paramvalue) {

    fetch(window.Shopify.routes.root + 'cart.js')
        .then(response => response.json())
        .then(body => {
            const current = body.attributes[paramname] || '';
            if (current != paramvalue) {
                addCartAttribute(paramname, paramvalue);
            }
        })
        .catch(err => console.log(err));

}

function addCartAttribute(paramname, paramvalue) {

    let attributes = {};
    attributes[paramname] = paramvalue;

    fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            attributes
        })
    })
    .then(response => response.json());
}